import script from "./resource.vue?vue&type=script&lang=ts&setup=true"
export * from "./resource.vue?vue&type=script&lang=ts&setup=true"

import "./resource.vue?vue&type=style&index=0&id=3190a469&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3190a469"]])

export default __exports__